import React, { useRef, useState } from 'react';
import ENUMS from '../../../enums/index';
import Select from 'react-select';
import '../../financialTransactions/financialTransactions.scss';
import DatePicker from './../../../components/FormElements/DatePicker/DatePicker';

const FinancialTransactionsFilter = props => {
  let formReference = useRef();
  let [selectedType, setSelectedTypes] = useState([]);
  let [userFullName, setUserFullName] = useState('');
  let [userMobileNumber, setUserMobileNumber] = useState();
  let [createdDateFrom, setCreatedDateFrom] = useState(' ');
  let [createdDateTo, setCreatedDateTo] = useState(' ');
  let [trackingNumber, setTrackingNumber] = useState();

  const resetForm = event => {
    Array.from(formReference.current).forEach(element => {
      if (element.type === 'radio' || element.type === 'checkbox') {
        element.checked = null;
      } else if (element.name === 'resetButton') {
        element.value = locales('fields.reset');
      } else {
        element.value = null;
      }
    });
    setSelectedTypes('');
    setCreatedDateFrom(' ');
    setCreatedDateTo(' ');
    setTrackingNumber('');
    setUserFullName('');
    setUserMobileNumber('');
    props.applyFilters(event);
  };

  return (
    <form
      ref={formReference}
      onReset={event => resetForm(event)}
      onSubmit={event => props.applyFilters(event)}
      id="filterForm"
      className="formCard p-3 mb-3"
    >
      <strong className="mb-3">{locales('titles.search')}</strong>

      <div className="col-12 d-flex form-group">
        <div className=" col-6">
          <label htmlFor="type" className="col-md-2 col-form-label">
            {locales('labels.financial.transaction.type')}
          </label>
          <div className="col-md-10">
            <Select
              placeholder={locales('placeholders.financial.transaction.type')}
              name="type"
              value={selectedType}
              options={ENUMS.FINANCIAL_TRANSACTION_TYPES.list.map(type => ({
                label: type.title,
                value: type.value,
              }))}
              onChange={selectedIds => setSelectedTypes(selectedIds)}
            />
          </div>
        </div>

        <div className="col-6">
          <label htmlFor="type" className="col-md-6 col-form-label">
            {locales('labels.financial.transaction.createdFrom')}
          </label>
          <label htmlFor="type" className="col-md-6 col-form-label">
            {locales('labels.financial.transaction.createdTo')}
          </label>
          <div className="form-group row d-flex">
            <div className="col-md-6 date-picker">
              <DatePicker
                marge={true}
                placeholder="تاریخ شروع"
                name="createdDateFrom"
                onChange={d => setCreatedDateFrom(d)}
                value={createdDateFrom}
                className="form-control created-date-from"
              />
            </div>

            <div className="col-md-6 date-picker">
              <DatePicker
                marge={true}
                placeholder="تاریخ پایان"
                onChange={d => setCreatedDateTo(d)}
                value={createdDateTo}
                name="createdDateTo"
                className="form-control created-date-to"
              />
            </div>
          </div>
        </div>
      </div>

      <div className="form-row">
        <div className="col-12 text-left">
          <input
            name="resetButton"
            type="reset"
            value={locales('fields.reset')}
            className="btn btn-danger w-5 mx-2"
          />
          <button id="apply-filter-btn-userFinancial" type="submit" className="btn btn-success mr-3">
            {locales('fields.applyFilters')}
          </button>
        </div>
      </div>
    </form>
  );
};

export default FinancialTransactionsFilter;
